import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { setDesktopSubmenu, activateSubmenu } from "app-store-v2/app/actions"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import useNavigation from "helpers/use-navigation"
import { cn } from "styles/utils"

const InternalMenuItem = ({
  index,
  item,
  showSubmenu,
  submenu,
  updateSubmenu,
}) => {
  const isOpened = showSubmenu && item.name === submenu.name
  const keyboardProps = useNavigation({ direction: "horizontal" })
  const isLink = !!item.url

  return (
    <li key={index} role="none">
      <Button
        asChild={isLink}
        className={cn(
          "text-black-print tablet:p-6 widescreen:text-16 text-14 p-6 font-medium uppercase",
          isOpened &&
            "text-primary after:border-b-grey-10 after:z-9 before:absolute before:bottom-0 before:z-10 before:block before:size-0 before:border-8 before:border-b-white before:border-l-transparent before:border-r-transparent before:border-t-transparent after:absolute after:bottom-px after:block after:size-0 after:border-8 after:border-l-transparent after:border-r-transparent after:border-t-transparent",
          item.style?.className
        )}
        data-cy={
          isLink
            ? `header-menu-link-desktop-${index}-${item.name}`
            : `header-menu-top-level-${item.name}-desktop`
        }
        data-lc="menu"
        id={item.name}
        onMouseEnter={() => updateSubmenu(isLink ? "" : item)}
        role="menuitem"
        {...(!isLink && {
          "aria-controls": "nav_dropdown_menu",
          "aria-expanded": isOpened,
          "aria-haspopup": true,
          onClick: () => updateSubmenu(true),
        })}
        tabIndex={
          (showSubmenu && submenu.name ? isOpened : index === 0) ? 0 : -1
        }
        variant="text"
        {...keyboardProps}
      >
        {isLink ? (
          item.external ? (
            <a href={item.url} rel="noopener noreferrer" target="_blank">
              {item.name}
            </a>
          ) : (
            <Link to={item.url}>{item.name}</Link>
          )
        ) : (
          <>
            {item.name}
            <FontAwesomeIcon
              className={cn(
                "text-8 ml-4",
                isOpened ? "text-primary" : "text-grey-55"
              )}
              icon={faChevronDown}
            />
          </>
        )}
      </Button>
    </li>
  )
}

InternalMenuItem.propTypes = {
  index: PropTypes.number,
  item: PropTypes.object,
  showSubmenu: PropTypes.bool,
  submenu: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  updateSubmenu: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    showSubmenu: state.menu.showSubmenu,
    submenu: state.menu.desktopSubmenu,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateSubmenu: (cat) => {
      dispatch(activateSubmenu())
      dispatch(setDesktopSubmenu(cat))
    },
  }
}

const MenuItem = connect(mapStateToProps, mapDispatchToProps)(InternalMenuItem)

export default MenuItem
